import { SCOPES } from '../api';
import type { NavNode } from '@nyce/admin-kit/console';

/** The Onboarding group's pages (M17, `docs/onboarding-wizards.md`), in screen order (children of its node in `NAV`). */
export const ONBOARDING_NAV: NavNode[] = [
  {
    path: '/onboarding/customers',
    label: 'Customer checklist',
    requires: SCOPES.authRead,
    description: 'Per customer: which modules are set up, and the wizard for the rest.',
  },
  {
    path: '/onboarding/tenant',
    label: 'Customer & tenant',
    requires: SCOPES.authWrite,
    description: 'AUTH customer, tenant, claims, keys, aliases and the WorkServer’s client and options.',
  },
  {
    path: '/onboarding/installation',
    label: 'Installation',
    requires: SCOPES.admin,
    description: 'Register an installation: cluster, namespaces, database, AUTH tenant, backups.',
  },
  {
    path: '/onboarding/scim',
    label: 'SCIM (Entra ID)',
    requires: SCOPES.scimWrite,
    alsoRequires: [SCOPES.authWrite],
    description: 'Provision users and groups from the customer’s Entra ID.',
  },
  {
    path: '/onboarding/statistics',
    label: 'Statistics',
    requires: SCOPES.statsAdmin,
    description: 'Datacollector organization, ingest credential and the WorkServer’s collector options.',
  },
  {
    path: '/onboarding/buddy',
    label: 'nyceBuddy',
    requires: SCOPES.buddyAdmin,
    description: 'nyceBuddy3 organization, tenant, system and provisioning, the add-in and MCP.',
  },
  {
    path: '/onboarding/printqueue',
    label: 'Print queue & print servers',
    requires: SCOPES.printqueueWrite,
    description: 'Print queue tenant, WorkServer settings, and print servers with config file and installer.',
  },
  {
    path: '/onboarding/automation',
    label: 'Automation agent',
    requires: SCOPES.automationWrite,
    description: 'Gateway tenant, agent, routes, config file and installer, then AUTH.',
  },
];
